(() => {
  // run once
  if (window.__pickupAutoInjectLoaded) return;
  window.__pickupAutoInjectLoaded = true;

  function makeHost(container) {
    if (container.querySelector('pickup-availability')) return;

    const form = container.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');

    const host = document.createElement('pickup-availability');
    host.className = 'product__pickup-availabilities no-js-hidden';
    host.dataset.rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    if (variantInput && variantInput.value) {
      host.setAttribute('available', '');
      host.dataset.variantId = variantInput.value;
    }

    // lightweight placeholder; component will replace after fetch()
    host.innerHTML = `
      <template>
        <pickup-availability-preview class="pickup-availability-preview">
          <div class="pickup-availability-info">
            <p class="caption-large">Select color/size to see store pickup availability.</p>
            <button class="pickup-availability-button link link--text underlined-link">Refresh</button>
          </div>
        </pickup-availability-preview>
      </template>
    `;

    form.after(host);
  }

  function mountAllWithin(root) {
    root
      .querySelectorAll('.product__info-container, [data-view="quick-add"], .quick-add, .quick-add-modal')
      .forEach(makeHost);
  }

  // initial pass
  mountAllWithin(document);

  // watch for Graphene inserting Quick Add nodes
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (
          node.matches('.product__info-container, [data-view="quick-add"], .quick-add, .quick-add-modal') ||
          node.querySelector('.product__info-container, [data-view="quick-add"], .quick-add, .quick-add-modal')
        ) {
          mountAllWithin(node);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });


    // === Dynamic top offset for pickup drawer (header + optional announcement bar) ===
  (function setupPickupDrawerTop() {
    // Common selectors across Dawn/Graphene variants — tweak if your theme differs
    const HEADER_SELECTORS = [
      'sticky-header',
      '.header-wrapper',
      '#shopify-section-header .header',
      'header.header',
      'header[role="banner"]'
    ];
    const ANNOUNCE_SELECTORS = [
      '.announcement-bar-section .utility-bar',
      '.announcement-bar-section .announcement-bar',
      '.utility-bar.custom-announcement-bar-styling',
      '.announcement-bar'
    ];

    const $first = (sels) => {
      for (const s of sels) {
        const el = document.querySelector(s);
        if (el) return el;
      }
      return null;
    };

    const isShown = (el) => {
      if (!el) return false;
      const cs = getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetHeight > 0;
    };

    // Only count the portion that’s actually at the top of viewport (announcement collapses on scroll)
    const visibleTopHeight = (el) => {
      if (!isShown(el)) return 0;
      const r = el.getBoundingClientRect();
      return r.bottom > 0 ? Math.min(r.height, r.bottom) : 0;
    };

    const applyTop = () => {
      const header = $first(HEADER_SELECTORS);
      const announce = $first(ANNOUNCE_SELECTORS);

      const headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      const announceH = Math.ceil(visibleTopHeight(announce));
      const computed = headerH + announceH;

      // Fallback to 103px if nothing is found
      const top = computed > 0 ? computed : 103;

      document.documentElement.style.setProperty('--pickup-drawer-top', `${top}px`);
      document.body?.style.setProperty('--pickup-drawer-top', `${top}px`);
    };

    // Debounce with rAF for scroll/resize
    let raf;
    const schedule = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(applyTop);
    };

    ['DOMContentLoaded','load','resize','scroll'].forEach(evt =>
      window.addEventListener(evt, schedule, { passive: true })
    );

    // Recompute if announcement bar toggles visibility/classes
    const announceSection =
      document.querySelector('.announcement-bar-section') ||
      document.querySelector('[id*="announcement-bar"]');

    if (announceSection) {
      new MutationObserver(schedule).observe(announceSection, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class','style','hidden','aria-hidden']
      });
    }

    // First run
    applyTop();
  })();

})();
